var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail34-template',{attrs:{"board-ids":[348],"field-code":"facility","com-group-list":_vm.comGroupList,"graph1-title":"전체 (시설물)안전·보건 확보 의무 현황","graph2-title":"월별 (시설물)안전·보건 확보 의무 현황","graph3-title":"기간별 (시설물)안전·보건 확보 의무 현황","hide-board-button":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }